// src/components/Profile/OrdersSection.jsx
import React, { useState } from 'react';

export default function OrdersSection({
  displayOrders,
  expandedOrders,
  showMoreOrders,
  onToggleExpand,
  onViewDetails,
  onToggleShowMore,
  formatDate,
  getStatusStyle
}) {
  const visibleOrders = showMoreOrders ? displayOrders : displayOrders.slice(0, 4);

  return (
    <div className="orders-card card-animate">
      <div className="card-header">
        <h3>My Orders</h3>
      </div>

      <div className="orders-list">
        {displayOrders.length > 0 ? (
          visibleOrders.map((order) => {
            const statusStyle = getStatusStyle(order.status);
            const isExpanded = expandedOrders[order.id];

            return (
              <div key={order.id} className="order-item-expandable">
                <OrderItemWithHover
                  order={order}
                  isExpanded={isExpanded}
                  statusStyle={statusStyle}
                  onToggleExpand={onToggleExpand}
                  formatDate={formatDate}
                />

                {isExpanded && (
                  <div className="order-details-preview">
                    <div className="row g-2 mb-3 p-3 bg-light rounded">
                      <div className="col-md-12 col-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-medium text-dark">Total Amount:</span>
                          <span className="fw-bold text-dark fs-5">
                            ${parseFloat(order.total_amount).toFixed(2)}
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12 col-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-medium text-dark">Items:</span>
                          <span className="fw-semibold text-dark">
                            {order.items?.length || 0} item(s)
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        onViewDetails(order);
                      }}
                      style={{ background: '#8b5cf6', borderColor: '#8b5cf6' }}
                    >
                      <i className="ph ph-eye"></i>
                      View Full Details
                    </button>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <p className="text-center text-gray-500">No orders yet</p>
        )}
      </div>

      {displayOrders.length > 4 && (
        <button className="show-more-btn" onClick={onToggleShowMore}>
          {showMoreOrders ? 'Show Less' : `Show More (${displayOrders.length - 4})`}
        </button>
      )}
    </div>
  );
}

// Helper component to handle hover state
function OrderItemWithHover({ order, isExpanded, statusStyle, onToggleExpand, formatDate }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="order-item"
      onClick={() => onToggleExpand(order.id)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ cursor: 'pointer' }}
    >
      <div className="order-info">
        <div
          className="order-id"
          style={{ color: isHovered ? '#1F2937' : '#FFFFFF', transition: 'color 0.3s ease' }}
        >
          #{order.order_number}
        </div>
        <div
          className="order-date"
          style={{ color: isHovered ? '#1F2937' : '#FFFFFF', transition: 'color 0.3s ease' }}
        >
          {formatDate(order.created_at)}
        </div>
        {order.total_items_in_order > 1 && (
          <div
            className="item-indicator"
            style={{
              fontSize: '11px',
              color: isHovered ? '#1F2937' : '#6b7280',
              marginTop: '4px',
              fontWeight: 500,
              transition: 'color 0.3s ease'
            }}
          >
            Item {order.item_index + 1} of {order.total_items_in_order}
          </div>
        )}
      </div>
      <div className={`order-status ${statusStyle.class}`}>
        <i className={`ph ${statusStyle.icon}`}></i>
        <span>{order.status}</span>
      </div>
      <i className={`ph ph-caret-${isExpanded ? 'up' : 'down'} expand-icon`}></i>
    </div>
  );
}